export const themeProps = {
    token: {
        colorPrimary: '#516f90',
        successColor: '#1f7d3d',
        infoColor: '#1890ff',
        errorColor: '#c00000',
        highlightColor: '#ff5c35',
        componentBackground: '#ffffff',
        headingColor: '#002945',
        textColorInverse: '#ffffff',
        headingColorDark: '#fef4ea',
        textColorDark: '#ffffff',
        fontSize: 12.88,
    },
    components: {
        Typography: {
            fontSizeHeading3: 24,
            fontSizeHeading4: 19.2,
        },
        Table: {
            headerBg: '#fef4ea',
            paddingSM: 3,
            padding: 3,
            paddingContentVerticalLG: 3,
            paddingXXS: 3,
            fontWeightStrong: 500,
            controlItemBgActiveHover: '#d8f3f9',
        },
        Collapse: {
            borderRadiusLG: 8,
        },
        Button: {
            colorPrimary: '#1f7d3d',
            colorPrimaryHover: '#188f5e',
            colorPrimaryActive: '#146a45',
        },
        Radio: {
            colorPrimary: '#ff5c35',
            colorPrimaryHover: '#e04c2f',
        },
        Checkbox: {
            colorPrimary: '#ff5c35',
            colorPrimaryHover: '#e04c2f',
        },
        Tooltip: {
            colorBgDefault: '#000',
            colorText: '#fff',
            fontSize: 14,
            padding: 8,
            borderRadius: 6,
            lineHeight: 1.5714,
            controlHeight: 32,
            sizePopupArrow: 16,
        },
    },
};
//# sourceMappingURL=themeProps.js.map